import React from 'react';
import companyLogo from '../Assets/Images/logo-a.png';


export const Footer = () => {
  return (
    <div className='bg-[#181818] w-full h-[300px] flex flex-col justify-center items-center'>
        <img src={companyLogo} className="lg:w-[180px] w-[120px]" alt="logo" />
        <p className='px-4 py-4 text-xl text-white font-lg'>Building excellence in civil construction, specializing in retaining walls and residential work for over 15 years.</p>
        <p className='text-[#fd8700] font-lg text-xl px-2 '>Contact Kane Morley - <a href="tel:0424 628 959"></a>0424 628 959</p>
        <p className='pt-12 text-white'>© Copyright 2023 KJM</p>
    </div>
  )
}
